import Button, { SubmitWrapper } from "@/shared/form/button";
import { PersonSelectExtendedField } from "./person-select-extended-field";
import { useTranslations } from "use-intl";
import { SelectProps } from "@/shared/form/select";

export type PersonSelectExtendedProps = {
  close: () => void;
  onChange?: (values: string | string[] | undefined) => void;
  value?: string | string[];
  mode: SelectProps["mode"];
};

export function PersonSelectExtended({
  close,
  ...rest
}: PersonSelectExtendedProps) {
  const t = useTranslations("Common");

  return (
    <div>
      <PersonSelectExtendedField {...rest} />
      <div className="mt-3">
        <SubmitWrapper>
          <Button type="primary" onClick={close}>
            {t("Close")}
          </Button>
        </SubmitWrapper>
      </div>
    </div>
  );
}
